import {getBusinessList, onlineMachineryList, selectCompanyStatistics} from "@/api/screenStatistics.js";
import { getOrderList } from "@/api/projectManage.js";
import { getSupplyInfoOfMaterials, getSupplyInfoOfService, } from "@/api/supplyDemand.js";
import CompanyInfoWindow from "@/views/productionService/components/companyInfoWindow.vue";
import OrderInfoWindow from "@/views/productionService/components/orderInfoWindow.vue";
import AgriculturalInfoWindow from "@/views/productionService/components/agriculturalInfoWindow.vue";
import MachineryServiceInfoWindow from "@/views/productionService/components/machineryServiceInfoWindow.vue";

import businessInfoWindow from "@/views/screenStatistics/components/businessInfoWindow";
import machineryInfoWindow from "@/views/screenStatistics/components/machineryInfoWindow";
import machineryServiceInfo from "@/views/screenStatistics/components/machineryServiceInfoWindow";
import companyServiceInfoWindow from "@/views/screenStatistics/components/companyInfoWindow";

//天地图秘钥
// export const TDT_TOKEN = 'ef8a332f7dd33194cf3a190c81084d3c';
export const TDT_TOKEN = 'bcc62222fc634ec736589c483de933e6';

//颜色
export const COLORS = {
    primary: '#3498db',
    secondary: '#2ecc71',
    danger: '#e74c3c'
};

//点类型
export const MARKER_TYPES = {
    company: 1,  //托管服务商
    machinery: 2,  //农机服务商
    order: 3,  //托管地块
    agricultural: 4,  //农资商
}

// 驾驶舱点类型
export const DASHBOARD_MARKER_TYPES = {
  agricultural: 5,  //农资商
  machineryCar: 6,  // 在线农机
  business: 7,  // 经营主体
  companyService: 8,  // 农事服务商
  machineryService: 9, // 农机服务商
}

//图标
export const ICONS = {
    company: require("@/assets/农服商.png"),  //托管服务商
    machinery: require("@/assets/农服商.png"),  //农机服务商
    order: require("@/assets/地块1.png"),  //托管地块
    agricultural: require("@/assets/农资商.png"),  //农资商
    machineryCar: require("@/assets/农机.png"),  //农资商
    business: require("@/assets/经营主体.png"),  //农资商
}

//每次分批加载marker的量
export const MARKER_BATCH_SIZE = 500;

//marker相关api整合
export const API_STRATEGIES = {
    [MARKER_TYPES.company]: {
        getIcon: () => ICONS.company,
        getInfoComponent: () => CompanyInfoWindow,
        loadPage: (params) => selectCompanyStatistics({
            pageNo: params.current || 1,
            pageSize: params.size || MARKER_BATCH_SIZE,
            areaCode: params.areaCode || "",
            serviceType: params.serviceType || null,
        }),
        getTotal: (page) => page?.data?.total,
        getData: (page) => page?.data?.records,
        getMarkerId: (obj) => obj?.id  //obj为后端返回数据的单个对象（marker）
    },
    [MARKER_TYPES.machinery]: {
        getIcon: () => ICONS.machinery,
        getInfoComponent: () => MachineryServiceInfoWindow,
        loadPage: (params) => getSupplyInfoOfService({
            pnum: params.current || 1,
            psize: params.size || MARKER_BATCH_SIZE,
            areaCode: params.areaCode || "",
            serviceType: params.serviceType || null,
        }),
        getTotal: (page) => page?.dataNum,
        getData: (page) => page?.data
    },
    [MARKER_TYPES.order]: {
        getIcon: () => ICONS.order,
        getInfoComponent: () => OrderInfoWindow,
        loadPage: (params) => getOrderList({
            pnum: params.current || 1,
            psize: params.size || MARKER_BATCH_SIZE,
            areaCode: params.areaCode || "",
            orderType: params.orderType || null,
        }),
        getTotal: (page) => page?.dataNum,
        getData: (page) => page?.data,
        getMarkerId: (obj) => obj?.orderId
    },
    [MARKER_TYPES.agricultural]: {
        getIcon: () => ICONS.agricultural,
        getInfoComponent: () => AgriculturalInfoWindow,
        loadPage: (params) => getSupplyInfoOfMaterials({
            pnum: params.current || 1,
            psize: params.size || MARKER_BATCH_SIZE,
            areaCode: params.areaCode || "",
        }),
        getTotal: (page) => page?.dataNum,
        getData: (page) => page?.data
    },
    [DASHBOARD_MARKER_TYPES.machineryCar]: {
      getIcon: () => ICONS.machineryCar,
      getInfoComponent: () => machineryInfoWindow,
      loadPage: (params) => onlineMachineryList({
        pageNo: params.current || 1,
        pageSize: params.size || MARKER_BATCH_SIZE,
        areaCode: params.areaCode || "",
      }),
      getTotal: (page) => page?.data?.total,
      getData: (page) => page?.data?.records,
    },
    [DASHBOARD_MARKER_TYPES.business]: {
      getIcon: () => ICONS.business,
      getInfoComponent: () => businessInfoWindow,
      loadPage: (params) => getBusinessList({
        pageNo: params.current || 1,
        pageSize: params.size || MARKER_BATCH_SIZE,
        areaCode: params.areaCode || "",
      }),
      getTotal: (page) => page?.data?.total,
      getData: (page) => page?.data?.records,
    },
    [DASHBOARD_MARKER_TYPES.companyService]: {
      getIcon: () => ICONS.company,
      getInfoComponent: () => companyServiceInfoWindow,
      loadPage: (params) => selectCompanyStatistics({
        pageNo: params.current || 1,
        pageSize: params.size || MARKER_BATCH_SIZE,
        areaCode: params.areaCode || "",
        serviceType: params.serviceType || null,
      }),
      getTotal: (page) => page?.data?.total,
      getData: (page) => page?.data?.records,
      getMarkerId: (obj) => obj?.id  //obj为后端返回数据的单个对象（marker）
    },
    [DASHBOARD_MARKER_TYPES.machineryService]: {
      getIcon: () => ICONS.machinery,
      getInfoComponent: () => machineryServiceInfo,
      loadPage: (params) => getSupplyInfoOfService({
        pnum: params.current || 1,
        psize: params.size || MARKER_BATCH_SIZE,
        areaCode: params.areaCode || "",
        serviceType: params.serviceType || null,
      }),
      getTotal: (page) => page?.dataNum,
      getData: (page) => page?.data
    },
};
